module.exports = __webpack_public_path__ + "img/linkedinicon.d398024a.svg";